export const uk = {
    cases: 'Кейсы',
    help: 'Помощь',
    'online-courses': 'Онлайн курсы',
    site: 'Сайт',
    study: 'Обучение'
};
